import React from "react";
import { Link, withRouter } from "react-router-dom";

const Columns = (addUpd, destroy) => {
  let columns = [
    {
      id: "name",
      name: "Nombre",
      selector: (row) => row.name,
      sortable: true,
      wrap: true,
    },
    {
      id: "actions",
      name: "Acciones",
      width: "20%",
      button: true,
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="pe-2">
            <button
              className="btn btn-primary btn-sm"
              title="Editar usuario"
              onClick={() => addUpd(row)}
            >
              <i className="fas fa-edit"></i>
            </button>
          </div>
          <div className="pe-2">
            <button
              className="btn btn-danger btn-sm"
              title="Eliminar plan"
              onClick={() => destroy(row.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        </div>
      ),
    },
  ];
  return columns;
};

export default Columns;
